import React, { useState } from 'react';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import InputAdornment from '@material-ui/core/InputAdornment';
import { makeStyles } from '@material-ui/core/styles';
import { _validateEmail } from './../axios';
import { validateFields}  from '../helpers/validateFields';
import ClipLoader from 'react-spinners/ClipLoader';
import { css } from '@emotion/core';

const override = css`
    display: block;
    margin: 0 auto;
    border-color: gray;
`;

const useStyles = makeStyles(theme => ({
    dense: {
        marginTop: theme.spacing(2),
        backgroundColor: 'white',
    },
    menu: {
        width: 200,
    },
}));

const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const ContactInformation = (props) => {

    const [firstNameRequired, setFirstNameRequired] = useState(false);
    const [lastNameRequired, setLastNameRequired] = useState(false);
    const [languageRequired, setLanguageRequired] = useState(false);
    const [emailRequired, setEmailRequired] = useState(false);
    const [emailMessageError, setEmailMessageError] = useState('');
    const [emailLoading, setEmailLoading] = useState(false);

    const validateEmail = async () => {

        const emailInput = document.getElementById('contactEmailAddress');
        const isEmailFormatValid = emailRegex.test(emailInput.value);
        setEmailLoading(true);
        if (isEmailFormatValid) {
            const { data } = await _validateEmail(emailInput.value);
            console.log(data);
            if (!data.isAvailable) {
                setEmailMessageError('Email already in use');
                setEmailRequired(true);
                props.setButtonDisabled(true);
                setEmailLoading(false);
            }
            else { setEmailLoading(false); setEmailRequired(false); const isValid = await validateFields(); props.setButtonDisabled(isValid); }
        } else {
            setEmailMessageError('Invalid email');
            setEmailRequired(true);
            setEmailLoading(false);
        }
    }

    const languages = [
        {
            value: 'en',
            label: 'English'
        },
        {
            value: 'eu',
            label: 'Spanish'
        },
        {
            value: 'pt',
            label: 'Portuguese'
        },
    ];

    const [values, setValues] = React.useState({
        language: '',
    });

    const handleChange = name => event => {
        setValues({ ...values, [name]: event.target.value });
    };


    const classes = useStyles();
    return (
        <Grid container spacing={1}>
            <Grid item xs={12} sm={12}>
                <h2>Contact Information:</h2>
            </Grid>
            <Grid item xs={12} sm={6}>
                {(firstNameRequired) ? <label style={{ color: 'red', fontSize: '12px', float: 'right', }}>* Required</label> : <label></label>}
                <TextField
                    error={firstNameRequired}
                    label="First Name"
                    id="contactFirstName"
                    className={classes.dense}
                    margin="dense"
                    variant="outlined"
                    style={{ marginTop: firstNameRequired ? '3px' : '16px', }}
                    onInput={async(e) => {

                        e.target.value = (e.target.value !== '') ? e.target.value.slice(0, 125) : ''
                        const isValid = await validateFields();
                        props.setButtonDisabled(isValid);
                    }}
                    onBlur={async(e) => {
                        (e.target.value.length > 0) ? setFirstNameRequired(false) : setFirstNameRequired(true);
                        const isValid = await validateFields();
                        props.setButtonDisabled(isValid);
                    }}
                    fullWidth={true} />
            </Grid>
            <Grid item xs={12} sm={6}>
                {(lastNameRequired) ? <label style={{ color: 'red', fontSize: '12px', float: 'right', }}>* Required</label> : <label></label>}
                <TextField
                    label="Last Name"
                    error={lastNameRequired}
                    id="contactLastName"
                    className={classes.dense}
                    margin="dense"
                    variant="outlined"
                    style={{ marginTop: lastNameRequired ? '3px' : '16px', }}
                    onInput={async(e) => {
                        e.target.value = (e.target.value !== '') ? e.target.value.slice(0, 125) : ''
                        const isValid = await validateFields();
                        props.setButtonDisabled(isValid);
                    }}
                    onBlur={async(e) => {
                        (e.target.value.length > 0) ? setLastNameRequired(false) : setLastNameRequired(true);
                        const isValid = await validateFields(); props.setButtonDisabled(isValid);
                    }}
                    fullWidth={true} />
            </Grid>
            <Grid item xs={12} sm={6}>
                {(emailRequired) ? <label style={{ color: 'red', fontSize: '12px', float: 'right', }}>* {emailMessageError}</label> : <label></label>}
                <TextField
                    error={emailRequired}
                    label="Email Address"
                    id="contactEmailAddress"
                    className={classes.dense}
                    margin="dense"
                    variant="outlined"
                    style={{ marginTop: emailRequired ? '3px' : '16px', }}
                    onInput={async(e) => {
                        e.target.value = (e.target.value !== '') ? e.target.value.slice(0, 256) : ''
                        const isValid = await validateFields();
                        props.setButtonDisabled(isValid);
                    }}
                    onBlur={async(e) => { if (e.target.value.length > 0) { setEmailRequired(false); validateEmail(); } else { setEmailMessageError('Required'); setEmailRequired(true); } }}
                    fullWidth={true}
                    InputProps={{
                        endAdornment: <InputAdornment position="end"> <ClipLoader
                        css={override}
                        sizeUnit={"px"}
                        size={15}
                        loading={emailLoading}
                    /></InputAdornment>,
                      }}
                     />
            </Grid>
            <Grid item xs={12} sm={6}>
                <label style={{ fontSize: '12px', float: 'right', }}>* Optional</label>
                <TextField
                    id="contactPhone"
                    label="Phone"
                    className={classes.dense}
                    margin="dense"
                    variant="outlined"
                    style={{ marginTop: '3px', }}
                    onInput={async(e) => {
                        var x = e.target.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
                        e.target.value = !x[2] ? '+' + x[1] : '+' + x[1] + ' ' + x[2] + (x[3] ? '-' + x[3] : '');
                        e.target.value = (e.target.value !== '') ? e.target.value.slice(0, 256) : ''
                    }}
                    fullWidth={true} />
            </Grid>
            <Grid item xs={12} sm={12}>
                <label style={{ fontSize: '12px', float: 'right', }}>* Optional</label>
                <TextField
                    id="contactLanguage"
                    select
                    label="Language"
                    className={classes.dense}
                    margin="dense"
                    variant="outlined"
                    value={values.language}
                    style={{ marginTop: '3px', }}
                    onChange={handleChange('language')}
                    SelectProps={{
                        MenuProps: {
                            className: classes.menu,
                        },
                    }}
                    fullWidth={true}>
                    {languages.map(option => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.label}
                        </MenuItem>
                    ))}
                </TextField>
            </Grid>
        </Grid>
    )
};

export default ContactInformation;